import type { ReactNode } from "react"

import { DocumentMinusIcon } from "@heroicons/react/24/outline"

export default function SystemPricingEmpty(): ReactNode {
  return (
    <div className="text-center">
      <DocumentMinusIcon className="mx-auto size-12 font-light text-gray-300" />
      <h3 className="mt-2 text-sm font-semibold text-gray-900">No pricing</h3>
      <p className="mt-1 text-sm text-gray-500">
        No Pricing Found for the Proposal.
      </p>
    </div>
  )
}
